<template>
    <div id="cvv-info">
        <div>
            The CVV number is a 3- or 4-digit security code, usually located on the back of your card.
        </div>
        <br/>
        <img id="credit-card-back" src="~@/assets/images/back-of-credit-card.png" />
    </div>
</template>

<script>
    export default {
        name: "CVVInfo"
    }
</script>

<style scoped>
    #cvv-info {
        background-color: var(--white);
    }
</style>